import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phulucduongsat from "components/Tonghopvantai/Phulucduongsat.js";
export default function PhulucduongsatTH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Phụ lục đường sắt",
            tabContent: <Phulucduongsat />,
          },
        ]}
      />
    </div>
  );
}
